import { Box, BoxProps, Image } from "@chakra-ui/react";
import { useHookstate } from "@hookstate/core";
import { appStore } from "../../../hookstate/appStore";

interface CountryFlagProps {
  countryId: string;
  small?: boolean;
}

export function CountryFlag({
  small,
  countryId,
  ...props
}: CountryFlagProps & BoxProps) {
  const flagUrl = useHookstate(appStore.countryFlagMap[countryId]).get();

  return (
    <Box
      width={small ? ".75rem" : ".875rem"}
      height={small ? ".75rem" : ".875rem"}
      borderRadius="50%"
      overflow="hidden"
      display="flex"
      justifyContent="center"
      alignItems="center"
      {...props}
    >
      <Image
        src={flagUrl}
        alt={`${countryId} country flag`}
        width="100%"
        height="100%"
        objectFit="cover"
      />
    </Box>
  );
}
